import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n";
import "./tasktypes/builtins";
import "./views";
import { App } from "./app/App";
import { installPluginHost } from "./registry/pluginLoader";
import "./capture/install"; // keeps Chrome's install offer for /install

installPluginHost();

// the installed app is a share target on Android (I2); service workers only run over HTTPS
if ("serviceWorker" in navigator && location.protocol === "https:")
  void navigator.serviceWorker.register("/sw.js").catch(() => undefined);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
